"use client";

/**
 * GitHub-style commit contribution heatmap.
 * Shows commit activity for a project over the last 52 weeks.
 */
import { c as _c } from "react/compiler-runtime";
interface CommitHeatmapProps {
  /** Array of 52 weekly commit counts, oldest first */
  weeks: number[];
  label?: string;
}
function getColor(count: number, maxCount: number): string {
  if (count === 0) return "bg-[hsl(230,15%,12%)]";
  const ratio = count / Math.max(maxCount, 1);
  if (ratio < 0.25) return "bg-emerald-900/60";
  if (ratio < 0.5) return "bg-emerald-700/70";
  if (ratio < 0.75) return "bg-emerald-500/80";
  return "bg-emerald-400";
}
export function CommitHeatmap(t0) {
  const $ = _c(14);
  const {
    weeks,
    label
  } = t0;
  const maxCount = Math.max(...weeks, 1);
  let t1;
  if ($[0] !== label || $[1] !== weeks) {
    const total = weeks.reduce(_temp, 0);
    t1 = label && <div className="flex items-center justify-between mb-3"><span className="text-sm font-medium text-gray-300">{label}</span><span className="text-xs text-gray-500">{total.toLocaleString()} commits in the last year</span></div>;
    $[0] = label;
    $[1] = weeks;
    $[2] = t1;
  } else {
    t1 = $[2];
  }
  let t2;
  if ($[3] !== maxCount || $[4] !== weeks) {
    let t3;
    if ($[6] !== maxCount) {
      t3 = (count, i) => <div key={i} className={`w-3 h-3 rounded-sm ${getColor(count, maxCount)} transition-colors`} title={`Week ${i + 1}: ${count} commits`} />;
      $[6] = maxCount;
      $[7] = t3;
    } else {
      t3 = $[7];
    }
    t2 = weeks.map(t3);
    $[3] = maxCount;
    $[4] = weeks;
    $[5] = t2;
  } else {
    t2 = $[5];
  }
  let t3;
  if ($[8] !== t2) {
    t3 = <div className="flex gap-[3px] overflow-x-auto pb-1">{t2}</div>;
    $[8] = t2;
    $[9] = t3;
  } else {
    t3 = $[9];
  }
  let t4;
  if ($[10] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <div className="flex items-center gap-1.5 mt-2 text-[10px] text-gray-500"><span>Less</span><div className="w-3 h-3 rounded-sm bg-[hsl(230,15%,12%)]" /><div className="w-3 h-3 rounded-sm bg-emerald-900/60" /><div className="w-3 h-3 rounded-sm bg-emerald-700/70" /><div className="w-3 h-3 rounded-sm bg-emerald-500/80" /><div className="w-3 h-3 rounded-sm bg-emerald-400" /><span>More</span></div>;
    $[10] = t4;
  } else {
    t4 = $[10];
  }
  let t5;
  if ($[11] !== t1 || $[12] !== t3) {
    t5 = <div>{t1}{t3}{t4}</div>;
    $[11] = t1;
    $[12] = t3;
    $[13] = t5;
  } else {
    t5 = $[13];
  }
  return t5;
}
function _temp(a, b) {
  return a + b;
}